// プライムコースかどうか
export const isPrime = (subscriptionInfoUuid: string): boolean => {
  return subscriptionInfoUuid === "04643bac-eb7d-4358-a3b3-5090efef2378";
};

// スマイルコースかどうか
export const isSmile = (subscriptionInfoUuid: string): boolean => {
  return subscriptionInfoUuid === "f989aa4b-d8df-4f0d-881c-d0660b2e1575";
};

// プチコースかどうか
export const isPutit = (subscriptionInfoUuid: string): boolean => {
  return subscriptionInfoUuid === "67ee921d-4451-4fb5-adea-e393e8e4c091";
};

// ファーストセレクションかどうか;
export const isFirstSelection = (subscriptionInfoUuid: string): boolean => {
  return (
    subscriptionInfoUuid === "c1dc98a8-5034-4e3c-9c00-32ea4a31f8fe" ||
    subscriptionInfoUuid === "6ef85741-b1aa-4668-8339-1fed73e3680b" ||
    subscriptionInfoUuid === "08e1c048-d8a2-4d6f-9fca-81702024f89e" ||
    subscriptionInfoUuid === "344e1883-23e3-4a0c-a99c-ce01427b5f3e"
  );
};

// スタンダードの一括払いかどうか
export const isOneTimePaymentStandard = (subscriptionInfoUuid: string): boolean => {
  return (
    // 一年払い
    subscriptionInfoUuid === "4e727447-7085-4432-b9bc-8130cb9acbb0" ||
    // 半年払い
    subscriptionInfoUuid === "4b50a0e0-9aed-4e68-a052-63b61238879f"
  );
};

export const isKonamiSports = (subscriptionInfoUuid: string): boolean => {
  return subscriptionInfoUuid === "0971e2e9-6982-4234-aad3-f8367438a52e";
};
